module.exports = __webpack_public_path__ + "static/media/csrd_report3.5da13d56.svg";